<template>
  <component
    :is="componente"
    :item="item"
  />
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue'
import { ResultadoBusca } from '../../../../common/types/Busca'
import ItemIrmao from './ItemIrmao.vue'
import ItemPotencia from '@/components/ItemPotencia.vue'
import ItemLoja from '@/components/ItemLoja.vue'
import ItemEsposa from './ItemEsposa.vue'
import ItemServico from './ItemServico.vue'

const props = defineProps({
	item: { type: Object as PropType<ResultadoBusca>, required: true },
})

const componente = computed(() => {
	switch (props.item.resultType) {
		case 'irmao': return ItemIrmao
		case 'loja': return ItemLoja
		case 'potencia': return ItemPotencia
		case 'esposa': return ItemEsposa
		case 'servico': return ItemServico
		default: return 'div'
	}
})
</script>
